var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-overlay",
    {
      staticClass: "p-3 border rounded",
      staticStyle: { "max-height": "500px", "overflow-y": "scroll" },
      attrs: { show: _vm.loading },
    },
    [
      _c(
        "b-row",
        { staticClass: "grid" },
        [
          _vm._l(_vm.equalSizes, function (equalSize) {
            return _c(
              "a",
              {
                key: equalSize.name,
                staticClass: "col-sm-6 col-lg-4 col-xl-3 mb-3",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.selectSize(equalSize)
                  },
                },
              },
              [
                _c("mount-kit-design-option", {
                  attrs: {
                    "frame-size":
                      _vm.sizeType == "artwork" ? equalSize : _vm.size,
                    "item-size":
                      _vm.sizeType == "artwork" ? _vm.size : equalSize,
                    "board-code": _vm.boardCode,
                    selected: equalSize.name == _vm.selectedOtherSize.name,
                    "from-price": _vm.fromPrice,
                  },
                }),
              ],
              1
            )
          }),
          _vm._l(_vm.unequalSizes, function (unequalSize) {
            return _c(
              "a",
              {
                key: unequalSize.name,
                staticClass: "col-sm-6 col-lg-4 col-xl-3 mb-3",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.selectSize(unequalSize)
                  },
                },
              },
              [
                _c("mount-kit-design-option", {
                  attrs: {
                    "frame-size":
                      _vm.sizeType == "artwork" ? unequalSize : _vm.size,
                    "item-size":
                      _vm.sizeType == "artwork" ? _vm.size : unequalSize,
                    "board-code": _vm.boardCode,
                    selected: unequalSize.name == _vm.selectedOtherSize.name,
                    "from-price": _vm.fromPrice,
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }